import actions from "./disclaimers-actions";
import getters from "./disclaimers-getters";
import mutations from "./disclaimers-mutations";
import state from "./disclaimers-state";
const store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
export default store;